import { isMobile } from '@benzinga/device-utils';

import styles from './ScrollRevealFloating.module.scss';

export type ScrollRevealShellVariant = 'default' | 'blocks';

export function getScrollRevealShellClassName(isRevealed: boolean, variant: ScrollRevealShellVariant = 'default') {
  return [
    styles.floatingShell,
    variant === 'blocks' && styles.floatingShellWithBlocks,
    isRevealed && styles.visible,
    isRevealed && isMobile() && styles.isMobile,
  ]
    .filter(Boolean)
    .join(' ');
}
